import type { WebPixelCreatePayload, WebPixelUpdatePayload } from '~/schemas/shopify/admin.types';
import type { UseMutationOptions } from '@tanstack/react-query';
import type Types from '~/api/graphql/type';

import { useMutation } from '@tanstack/react-query';
import { fetchFromAPI } from '~/api/utils';

const mutationKey = 'webPixel';
export type WebPixelMutationVariables = Types.Exact<{
  variables: {
    input: {
      shopID: string;
    };
  };
}>;
export type WebPixelMutationResponse = WebPixelCreatePayload | WebPixelUpdatePayload;

export const useWebPixelMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    WebPixelMutationResponse,
    TError,
    WebPixelMutationVariables,
    TContext
  >,
) => {
  return useMutation<WebPixelMutationResponse, TError, WebPixelMutationVariables, TContext>({
    mutationKey: [mutationKey],
    mutationFn: (variables?: WebPixelMutationVariables): Promise<WebPixelMutationResponse> =>
      fetchFromAPI(`/api/web-pixel/query`, {
        method: 'POST',
        body: JSON.stringify(variables),
      }),
    ...options,
  });
};

useWebPixelMutation.getKey = (variables?: WebPixelMutationVariables) => [mutationKey, variables];
